
export const indianStates = [
  {
    'id': 'Andhra Pradesh',
    'label': 'Andhra Pradesh',
    'gstCode': '37',
  },
  {
    'id': 'Arunachal Pradesh',
    'label': 'Arunachal Pradesh',
    'gstCode': '12',
  },
  {
    'id': 'Assam',
    'label': 'Assam',
    'gstCode': '18',
  },
  {
    'id': 'Bihar',
    'label': 'Bihar',
    'gstCode': '10',
  },
  {
    'id': 'Chhattisgarh',
    'label': 'Chhattisgarh',
    'gstCode': '22',
  },
  {
    'id': 'Goa',
    'label': 'Goa',
    'gstCode': '30',
  },
  {
    'id': 'Gujarat',
    'label': 'Gujarat',
    'gstCode': '24',
  },
  {
    'id': 'Haryana',
    'label': 'Haryana',
    'gstCode': '06',
  },
  {
    'id': 'Himachal Pradesh',
    'label': 'Himachal Pradesh',
    'gstCode': '02',
  },
  {
    'id': 'Jharkhand',
    'label': 'Jharkhand',
    'gstCode': '20',
  },
  {
    'id': 'Karnataka',
    'label': 'Karnataka',
    'gstCode': '29',
  },
  {
    'id': 'Kerala',
    'label': 'Kerala',
    'gstCode': '32',
  },
  {
    'id': 'Madhya Pradesh',
    'label': 'Madhya Pradesh',
    'gstCode': '23',
  },
  {
    'id': 'Maharashtra',
    'label': 'Maharashtra',
    'gstCode': '27',
  },
  {
    'id': 'Manipur',
    'label': 'Manipur',
    'gstCode': '14',
  },
  {
    'id': 'Meghalaya',
    'label': 'Meghalaya',
    'gstCode': '17',
  },
  {
    'id': 'Mizoram',
    'label': 'Mizoram',
    'gstCode': '15',
  },
  {
    'id': 'Nagaland',
    'label': 'Nagaland',
    'gstCode': '13',
  },
  {
    'id': 'Odisha',
    'label': 'Odisha',
    'gstCode': '21',
  },
  {
    'id': 'Punjab',
    'label': 'Punjab',
    'gstCode': '03',
  },
  {
    'id': 'Rajasthan',
    'label': 'Rajasthan',
    'gstCode': '08',
  },
  {
    'id': 'Sikkim',
    'label': 'Sikkim',
    'gstCode': '11',
  },
  {
    'id': 'Tamil Nadu',
    'label': 'Tamil Nadu',
    'gstCode': '33',
  },
  {
    'id': 'Telangana',
    'label': 'Telangana',
    'gstCode': '36',
  },
  {
    'id': 'Tripura',
    'label': 'Tripura',
    'gstCode': '16',
  },
  {
    'id': 'Uttar Pradesh',
    'label': 'Uttar Pradesh',
    'gstCode': '09',
  },
  {
    'id': 'Uttarakhand',
    'label': 'Uttarakhand',
    'gstCode': '05',
  },
  {
    'id': 'West Bengal',
    'label': 'West Bengal',
    'gstCode': '19',
  },
  {
    'id': 'Andaman and Nicobar Islands',
    'label': 'Andaman and Nicobar Islands',
    'gstCode': '35',
  },
  {
    'id': 'Chandigarh',
    'label': 'Chandigarh',
    'gstCode': '04',
  },
  {
    'id': 'Dadra and Nagar Haveli and Daman and Diu',
    'label': 'Dadra and Nagar Haveli and Daman and Diu',
    'gstCode': '26',
  },
  {
    'id': 'Lakshadweep',
    'label': 'Lakshadweep',
    'gstCode': '31',
  },
  {
    'id': 'Delhi',
    'label': 'Delhi',
    'gstCode': '07',
  },
  {
    'id': 'Puducherry',
    'label': 'Puducherry',
    'gstCode': '34',
  },
  {
    'id': 'Ladakh',
    'label': 'Ladakh',
    'gstCode': '38',
  },
  {
    'id': 'Jammu and Kashmir',
    'label': 'Jammu and Kashmir',
    'gstCode': '01',
  },
];

export const GST_REGISTERED_STATES = [
  {
    'id': 'Goa',
    'label': 'Goa',
    'gstCode': '30',
  },
  {
    'id': 'Karnataka',
    'label': 'Karnataka',
    'gstCode': '29',
  },
  {
    'id': 'Maharashtra',
    'label': 'Maharashtra',
    'gstCode': '27',
  },
  {
    'id': 'Tamil Nadu',
    'label': 'Tamil Nadu',
    'gstCode': '33',
  },
];